var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { useInitialized } from '../../utils/use-initialized';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useLockScroll } from '../../utils/use-lock-scroll';
var classPrefix = "iweb-mask";
export var Mask = function (props) {
  var _a;
  var cls = classNames(classPrefix, props.className, (_a = {}, _a[classPrefix + "-hidden"] = !props.visible, _a));
  var initialized = useInitialized(props.visible || props.forceRender);
  var ref = useRef(null);
  useLockScroll(ref, !!(props.visible && props.disableBodyScroll));
  function handleClick(e) {
    var _a;
    if (e.currentTarget === e.target) {
      (_a = props.onMaskClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }
    e && e.stopPropagation();
  }
  var opacity = props.opacity === 'default' ? 0.55 : props.opacity === 'dark' ? 0.75 : props.opacity;
  var node = /*#__PURE__*/React.createElement("div", {
    className: cls,
    onClick: handleClick,
    ref: ref,
    style: __assign(__assign({}, props.style), {
      backgroundColor: "rgba(0, 0, 0, " + opacity + ")"
    })
  }, initialized && props.children);
  if (props.getContainer) {
    var container = typeof props.getContainer === 'function' ? props.getContainer() : props.getContainer;
    return /*#__PURE__*/createPortal(node, container);
  }
  return node;
};
Mask.defaultProps = {
  visible: true,
  destroyOnClose: false,
  forceRender: false,
  opacity: 'default',
  disableBodyScroll: true
};